import { useEffect, useRef } from "react";
import { loaderStop, setFUTOPTData, setFUTOPTErrorMsg, setTimeoutId } from "../Redux/features/Dashboard/DashBoardSlice";
import socket from "../socket";
import { useAppDispatch, useAppSelector } from "../Redux/app/hooks";

export const useFutOptSocketListener = () => {
  const dispatch = useAppDispatch();
  const isWaiting = useAppSelector((state) => state.dashBoard.fut_opt_loader);
  const timeoutId = useAppSelector((state) => state.dashBoard.timeoutId);

  // Refs to hold latest values
  const isWaitingRef = useRef(isWaiting);
  const timeoutIdRef = useRef(timeoutId);

  // Keep refs in sync
  useEffect(() => {
    isWaitingRef.current = isWaiting;
    timeoutIdRef.current = timeoutId;
  }, [isWaiting, timeoutId]);

  // Setup socket listener once
  useEffect(() => {
    const handleSocketResponse = (data: any) => {
      if (data?.Value?.socket_id === socket.id) {
        console.log("FUTURE|OPTIONS:: socket data:", data);

        if (isWaitingRef.current && timeoutIdRef.current) {
          clearTimeout(timeoutIdRef.current);
          dispatch(setTimeoutId(null));
          dispatch(loaderStop());
        }

        if (data?.Key === "ERROR") {
          dispatch(setFUTOPTErrorMsg(data?.Value?.msg));
          dispatch(
            setFUTOPTData({
              Key: "",
              Value: {
                cid: "",
                exc: "",
                futlst: [],
                optlst: [],
                rid: "",
                sec: "",
                sectype: "",
                vid: 0,
              },
            })
          );
        } else {
          dispatch(setFUTOPTErrorMsg(""));
          dispatch(setFUTOPTData(data));
        }
      } else {
        // dispatch(setFUTOPTErrorMsg(data?.Value?.msg));
        // dispatch(
        //   setFUTOPTData({
        //     Key: "",
        //     Value: {
        //       cid: "",
        //       exc: "",
        //       futlst: [],
        //       optlst: [],
        //       rid: "",
        //       sec: "",
        //       sectype: "",
        //       vid: 0,
        //     },
        //   })
        // );
      }
    };
    socket.on("futures-options-security-response", handleSocketResponse);

    return () => {
      socket.off("futures-options-security-response", handleSocketResponse);
    };
  }, []);
};
